import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../urunDiv.css';
import Limonata from '../../../../assets/menu/icecekler/soguk-icecekler/limonata.jpeg';
import PortakalSuyu from '../../../../assets/menu/icecekler/soguk-icecekler/portakal-suyu.jpeg';
import Milkshake from '../../../../assets/menu/icecekler/soguk-icecekler/milkshake.jpeg';
import Frozen from '../../../../assets/menu/icecekler/soguk-icecekler/frozen.jpeg';
import Ayran from '../../../../assets/menu/icecekler/soguk-icecekler/ayran.jpeg';
import FesleganliAyran from '../../../../assets/menu/icecekler/soguk-icecekler/fesleganli-ayran.jpeg';


const SogukIcecekler = () => {
	const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
			setIsPhone(window.innerWidth < 768);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const sogukIcecekKategorileri = {
		'Soğuk İçecekler': [
			{
				id: 1,
				name: 'Limonata',
				price: '₺179,90',
				image: Limonata
			},
			{
				id: 2,
				name: 'Portakal Suyu',
				price: '₺199,90',
				image: PortakalSuyu
			},
			{
				id: 3,
				name: 'Milkshake',
				price: '₺249,90',
				image: Milkshake
			},
			{
				id: 4,
				name: 'Frozen',
				price: '₺249,90',
				image: Frozen
			},
			{
				id: 5,
				name: 'Ayran',
				price: '₺119,90',
				image: Ayran
			},
			{
				id: 6,
				name: 'Fesleğenli Ayran',
				price: '₺139,90',
				image: FesleganliAyran
			}
		]
	};

	const handleIcecekClick = (icecek) => {
		if (icecek.name === 'Limonata') {
			navigate('/soguk-icecekler/limonata');
		} else if (icecek.name === 'Portakal Suyu') {
			navigate('/soguk-icecekler/portakal-suyu');
		} else if (icecek.name === 'Milkshake') {
			navigate('/soguk-icecekler/milkshake');
		} else if (icecek.name === 'Frozen') {
			navigate('/soguk-icecekler/frozen');
		} else if (icecek.name === 'Ayran') {
			navigate('/soguk-icecekler/ayran');
		} else if (icecek.name === 'Fesleğenli Ayran') {
			navigate('/soguk-icecekler/feslegenli-ayran');
		}
	};

	return (
		isPhone ? (
			<div className="urun-container">
				<div className="container" style={{ marginTop: '20px' }}>
					<h2 style={{ marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Soğuk İçecekler</h2>
				</div>

				{Object.entries(sogukIcecekKategorileri).map(([kategori, icecekler]) => (
					<div key={kategori}>
						<div className="container" style={{ marginTop: '20px' }}>
							<h2 style={{ marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
						</div>
						<hr style={{ color: '#D8D8D8' }} />
						<div className="urun-grid">
							{icecekler.map((icecek) => (
								<div
									key={icecek.id}
									className="urun-kart"
									onClick={() => handleIcecekClick(icecek)}
									style={{ cursor: 'pointer' }}
								>
									<div className="urun-bilgi">
										<h3 className="urun-ad">{icecek.name}</h3>
										<div className="urun-fiyat">{icecek.price}</div>
									</div>
									<div className="urun-resim">
										<img src={icecek.image} alt={icecek.name} style={{
											width: '80px',
											height: '80px',
											objectFit: 'cover',
											borderRadius: '100px',
										}} />
									</div>
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		) : (
			<div className="urun-container">
				<div className="container" style={{ marginTop: '20px' }}>
					<h2 style={{ marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Soğuk İçecekler</h2>
				</div>

				{Object.entries(sogukIcecekKategorileri).map(([kategori, icecekler]) => (
					<div style={{ marginBottom: '80px' }} key={kategori}>
						<div className="container" style={{ marginTop: '20px' }}>
							<h2 style={{ marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
						</div>
						<hr style={{ color: '#D8D8D8' }} />
						<div className="urun-grid-computer">
							{icecekler.map((icecek) => (
								<div
									key={icecek.id}
									className="urun-kart-computer"
									onClick={() => handleIcecekClick(icecek)}
									style={{ cursor: 'pointer' }}
								>
									<div className="urun-bilgi">
										<h3 className="urun-ad-computer">{icecek.name}</h3>
										<div className="urun-fiyat-computer">{icecek.price}</div>
									</div>
									<div className="urun-resim">
										<img src={icecek.image} alt={icecek.name} style={{
											width: '100px',
											height: '100px',
											objectFit: 'cover',
											borderRadius: '100px',
										}} />
									</div>
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		)
	);
};

export default SogukIcecekler;
